import clsx from 'clsx';

export default function TableHeaderTitle({ title, children, className }) {
  return (
    <div className={clsx('flex items-center justify-between gap-2', className)}>
      <span>{title}</span>

      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}
